import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import * as schemaStyles from './schema-viewer.module.scss'

function DefaultDisplay({ value }){ 

    const type = typeof value

    return (
        <>
            {
                type === 'object' ? 
                    <span>
                        {value.map(item => {
                            return <span key={item.source} className={schemaStyles.blockWrap}>
                                {JSON.stringify(item)}
                            </span>
                        })}
                    </span>
            : 
                <span className={schemaStyles.blockWrap}>
                    {String(value)}
                </span>
            }
        </>
    )
}


DefaultDisplay.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
};


function AttributesDisplay({attributes}){

    const required = attributes?.required
    return(
        <p>{attributes?.type} attributes: 
            <span className={schemaStyles.blockWrap} style={{flexDirection: 'column'}}>
                &#123;
                {
                    Object.entries(attributes?.properties).map(([key, value]) => {
                         return (
                            <span key={key} style={{margin: '0 1rem'}}>
                                <code style={{margin: '0', padding: '0', fontWeight: 'bold' }}>{key}</code>
                                    {required?.includes(key) ? <span style={{color: '#f46e2c'}}>&nbsp;required</span> : null} : &#123;  <br/>
                                    &nbsp;display name: {value?.title} <br/>
                                    &nbsp;type: {value?.type}
                                <br /> &#125;
                            </span>
                         )
                    })
                }
                &#125;
            </span>
        </p>
    )
}

AttributesDisplay.propTypes = {
    attributes: PropTypes.object.isRequired

};


function SchemaBlock({
        name, 
        value, 
        required,
    }){

        const type = value.type === "array" ? `${value.type}[${value?.items?.type}]` : value.type

        const itemAttributes = value?.items?.properties
 
        
        return (
            <div className={schemaStyles.schemaBlock} >
                <h3 className={schemaStyles.title}>
                    <span>
                        <span >{name}</span> - 
                        <span style={{color: 'var(--color-text-3)', fontWeight: 'normal' }}> {type}</span>
                    </span>
                    { required?.includes(name) ? <span className={schemaStyles.required}>required</span> : null}
                </h3>
                { value?.description ? <p>{value.description}</p> : null}
                { value?.maxLength ? <p><span className={schemaStyles.blockWrap}>&lt;= {value.maxLength} characters</span></p> : null}
                { value?.minLength ? <p><span className={schemaStyles.blockWrap}>&gt;= {value.minLength} characters</span></p> : null}
                { value?.pattern ? <p>Match pattern: <span className={schemaStyles.blockWrap}>{value.pattern}</span> </p> : null}
                

                { value?.minimum ? <p><span className={schemaStyles.blockWrap}>&gt;= {value.minimum}</span></p> : null}
                { value?.maximum ? <p><span className={schemaStyles.blockWrap}>&lt;= {value.maximum}</span></p> : null}
                { value?.exclusiveMinimum !== undefined ? <p>exclusiveMinimum: <span className={schemaStyles.blockWrap}>{String(value.exclusiveMinimum)}</span></p> : null}
                { value?.exclusiveMaximum !== undefined ? <p>exclusiveMaximum: <span className={schemaStyles.blockWrap}>{String(value.exclusiveMaximum)}</span></p> : null}


                
                { value?.default !== undefined ? <p>Default: <DefaultDisplay value={value.default} name={name}/></p> : null}

                { value?.enum ? <p style={{flexWrap: 'wrap'}}>Allowed values: <span style={{display:'flex',flexWrap:'wrap',marginLeft:'1rem',gap:'5px'}}>{value.enum.map(itm => <span className="block-wrap" key={itm}>{itm}</span>)}</span></p> : null}

                { value?.multipleOf !== undefined ? <p>Multiple of: <span className={schemaStyles.blockWrap}>{value.multipleOf}</span> </p> : null}
                {
                    itemAttributes !== undefined ? <AttributesDisplay attributes={value?.items} /> : null
                }
            </div>
        )
}

SchemaBlock.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    required:  PropTypes.array.isRequired,
};


function useArrayRef() {
    const refs = []
    return [refs, el => el && refs.push(el)]
}

function SchemaViewer({ config, isConnectorConfig = false }){

    const [hasBtns, setHasBtns] = useState(false)
    const [elements, ref] = useArrayRef()

    const required = config?.required

    useEffect(() => {
        if(elements?.length > 0){
            setHasBtns(true)
        }
    }, [elements]) 

    return (
      <section className={`article-margin ${isConnectorConfig ? 'isConnectorConfig' : ''}`}>
        {/* <h2 style={{fontSize: '1.4rem'}}>{config.title}</h2> */}
        <p>{config.description}</p>

        {
            hasBtns ? 
                <>
                    <button type="button" className={schemaStyles.schemaDetailsBtn} onClick={() => {elements.forEach(itm => { itm.open = true })}}>Expand all</button>
                    <button type="button" className={schemaStyles.schemaDetailsBtn} onClick={() => {elements.forEach(itm => { itm.open = false })}}>Collapse all</button>          
                </>
            : 
                null
        }

        <div style={{borderLeft: '1px solid var(--line-color)'}} >
          {
            Object.entries(config.properties).map(([key, value]) => {

                if(value?.properties === undefined || isEmpty(value?.properties) ){

                    return(
                        <React.Fragment key={key}>
                            {
                                value?.hints?.includes("hidden") ? null :
                                <SchemaBlock name={key} value={value} required={required}/>
                            }
                        </React.Fragment>
                    )
                }
                return (
                    <DetailsView 
                        key={`${key}-1`} 
                        keyName={key} 
                        title={value.title} 
                        description={value.description} 
                        properties={value?.properties}
                        ref={ref}
                    />
                )
            })
          }
        </div>
      </section>
      )
    }

SchemaViewer.propTypes = {
        config: PropTypes.object.isRequired,
        isConnectorConfig: PropTypes.bool
};


const DetailsView = React.forwardRef(({
    keyName,
    title,
    description,
    properties
}, ref ) => {

    return (
        <details 
            className={schemaStyles.schema}
            ref={ref}
            open={true}
        >
            <summary>
                <h3 className={schemaStyles.title}>
                    <span style={{color: 'var(--color-text)'}}>
                        {keyName} - 
                        <span style={{color: 'var(--color-text-3)', fontWeight: 'normal'}}>
                            &nbsp;{title}
                        </span>
                    </span> 
                </h3>
                <p>{description}</p>
            </summary>
            <div>
            {
                properties !== undefined
                    ? 
                        <div style={{borderLeft: '1px solid var(--line-color)'}}>
                            {
                                Object.entries(properties).map(([key, value]) => {

                                    const required = value?.required 

                                    if(value?.properties === undefined){
                                        return (
                                            <React.Fragment key={`${key}-2`}>
                                                {
                                                    value?.hints?.includes("hidden") ? null :
                                                    <SchemaBlock name={key} value={value} required={required}/>
                                                }
                                            </React.Fragment>
                                        )
                                    }

                                    return (
                                        <DetailsView key={`${key}-3`} 
                                            keyName={key} 
                                            title={value.title} 
                                            description={value.description}
                                            properties={value?.properties}
                                            ref={ref}
                                        />
                                    )
                                })
                            }
                        </div>
                    : 
                        null
            }
            </div>
        </details>
    )
})

DetailsView.displayName = 'DetailsView'

DetailsView.propTypes = {
    keyName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    properties: PropTypes.object.isRequired
};



export default SchemaViewer
